__turbopack_context__.v({
  "active": "zj1VFW_active",
  "price": "zj1VFW_price",
  "price-wrapper": "zj1VFW_price-wrapper",
  "root": "zj1VFW_root",
  "strikethrough": "zj1VFW_strikethrough",
  "tag": "zj1VFW_tag",
  "title": "zj1VFW_title",
});
